<div class="card item_card" [id]="place.id" style="max-width: 16rem; min-width: 16rem;">
  <div class="card-body item_card_res d-flex flex-row-reverse" >
    <div class=" col-sx-2">
        <div>
          <span (click)="delete(place)"  [title]="'Supprimer de la Configuration'">
            <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer de la Configuration"></i>
          </span>
        </div>
    </div>
  </div>
  <div class="card-footer">
    <p><i class="fas fa-map-marked-alt"></i> {{place.street}}</p>
    <P>Place N° : {{place.label}}</P>
  </div>
</div>
